import { configurationParser } from './configuration-create';
export interface QuickReplyCreateParams {
  channel?: General.PlatformUpperCase;
  group_type?: Phrase.Group['groupType'];
  phrase_group_id?: string;
  shortcut_key?: string;
  tags?: string[];
  regions?: General.UpperCaseRegion[];
  content?: string;
}
export function parseQuickReplyCreate(raw: unknown): QuickReplyCreateParams | undefined {
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return;
  for (const [key, value] of Object.entries(raw)) {
    if (['channel', 'group_type', 'regions'].includes(key)) {
      if (!configurationParser([key])({ [key]: value })) return;
    } else if (['phrase_group_id', 'shortcut_key', 'content'].includes(key)) {
      if (typeof value !== 'string' || value.length > 100000) return;
    } else if (key === 'tags') {
      if (!Array.isArray(value) || value.length > 3 || value.some((v) => typeof v !== 'string'))
        return;
    } else return;
  }
  return raw as QuickReplyCreateParams;
}
